import React from 'react';

import { MobileFilter2 } from '../../../filter/MobileFilter2';
import { RenovationFilter } from '../../../../models/Filter';
import { RenovationNewFilter } from '../../renovation/RenovationNewFilter';

interface IMobileRenovation {
    filter: RenovationFilter;
    handleChange: (value: RenovationFilter) => void;
    classNameGroup?: string;
}

export const MobileRenovationButtonFilterView: React.FC<IMobileRenovation> = ({
    filter,
    handleChange,
    classNameGroup
}) => {
    return (
        <MobileFilter2 filterTitle='Ремонт'>
            <RenovationNewFilter
                filter={filter}
                handleChange={handleChange}
                classNameGroup={classNameGroup}
            />
        </MobileFilter2>
    );
};
